import { GridItem } from "@chakra-ui/react";
import { useIntl } from "react-intl";

import { EventsList, EventsListModal } from "@/features/project-events";

import { ContentPanel } from "../../../components/content-panel";
import { DASHBOARD_GRID_ITEM_HEIGHT } from "../tenant-details";

export const LatestActivitiesBlock = () => {
  const intl = useIntl();

  return (
    <GridItem height={DASHBOARD_GRID_ITEM_HEIGHT}>
      <ContentPanel
        p={0}
        title={intl.formatMessage({
          id: "dashboard.my_latest_activity",
          defaultMessage: "My latest activity",
        })}
        rightLink={<EventsListModal filterBy="user" />}
      >
        <EventsList filterBy="user" />
      </ContentPanel>
    </GridItem>
  );
};
